import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Input,
	Output,
	ViewEncapsulation,
} from "@angular/core";
import { DepositLimitCalculation } from "@obg/ngx.common";

@Component({
	selector: "obg-m-deposit-limit-calculator-result",
	templateUrl: "./deposit-limit-calculator-result.component.html",
	styleUrls: ["./deposit-limit-calculator-result.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class DepositLimitCalculatorResultComponent {
	@HostBinding("class.obg-m-deposit-limit-calculator-result") class = true;

	@Input() calculation: DepositLimitCalculation | undefined;

	@Output() reset = new EventEmitter();
}
